// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  singletonId: __t.u8().primaryKey().name("singleton_id"),
  isPaused: __t.bool().name("is_paused"),
  updatedAt: __t.timestamp().name("updated_at"),
  updatedByIdentity: __t.string().name("updated_by_identity"),
});
